import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=44d3fb90&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=44d3fb90&prod&lang=scss"
import style1 from "./LeaderBoard.vue?vue&type=style&index=1&id=44d3fb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3fb90",
  null
  
)

export default component.exports